import { render } from "./App.vue?vue&type=template&id=228c7db8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=228c7db8&lang=scss"

import exportComponent from "D:\\Work\\订单系统\\Code\\glory_order_system_pc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__